import React from 'react';

const DairyzarLogo = ({ width = 180, height = 60 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 180 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Hexagon honey comb background */}
      <path
        d="M25 10L35 5L45 10L45 20L35 25L25 20Z"
        fill="#FFB800"
        opacity="0.2"
      />
      <path
        d="M15 20L25 15L35 20L35 30L25 35L15 30Z"
        fill="#FFB800"
        opacity="0.3"
      />

      {/* Main icon - Milk drop with leaf */}
      <g transform="translate(10, 15)">
        {/* Milk drop */}
        <path
          d="M20 5C20 5 12 15 12 22C12 27.5 15.5 32 20 32C24.5 32 28 27.5 28 22C28 15 20 5 20 5Z"
          fill="#006400"
        />
        <path
          d="M20 7C20 7 14 15 14 21C14 25.5 16.5 29 20 29C23.5 29 26 25.5 26 21C26 15 20 7 20 7Z"
          fill="#FFFFFF"
          opacity="0.3"
        />

        {/* Leaf accent */}
        <path
          d="M24 12C24 12 28 14 29 18C29 18 27 16 24 16C24 16 24 14 24 12Z"
          fill="#228B22"
        />
      </g>

      {/* Text "DAIRYZAR" */}
      <text
        x="55"
        y="35"
        fontFamily="'Poppins', Arial, sans-serif"
        fontSize="22"
        fontWeight="700"
        fill="#006400"
        letterSpacing="0.5"
      >
        DAIRYZAR
      </text>

      {/* Tagline */}
      <text
        x="55"
        y="48"
        fontFamily="'Poppins', Arial, sans-serif"
        fontSize="9"
        fontWeight="500"
        fill="#FFB800"
        letterSpacing="1.5"
      >
        PURE & NATURAL
      </text>

      {/* Decorative elements */}
      <circle cx="52" cy="35" r="1.5" fill="#FFB800" />
      <circle cx="172" cy="35" r="1.5" fill="#FFB800" />
    </svg>
  );
};

export default DairyzarLogo;
